import "@babel/polyfill";
import "base/scroll";
import "base/floating-nav";
import "slick-carousel";
import "base/products";
import "base/product-range-carousel";
import "base/ore-methods-read-more";
